import React from 'react';
import { useStyles } from './styles';
import { Box, Typography, Button } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

export const CustomAmountAlert = (props) => {

  const theme = useTheme()
  const classes = useStyles();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog fullScreen={fullScreen} PaperProps={{ classes: { root: classes.dialogStyle } }} open={true} onClose={props.handleClose}>
      <Box className={classes.root}>
        <Box className={classes.cardBody}>
          <Typography className={classes.statusTitle}>Custom Amount Acknowledgement</Typography>
        </Box>
        <Box className={classes.cardBody}>
           <Typography className={classes.statusSubTitle}>Amounts entered will be applied to past and current due payments, then any outstanding fees or charges. If the amount entered does not fully cover a due payment, funds will remain in unapplied until a full payment is completed. Once the loan is fully current, funds will apply toward future payments or toward curtailment based on specific loan criteria.
           </Typography>
          <Box className={classes.cardFooter}>
          <Button
            variant='contained'
            color='primary'
            className={classes.btn}
            onClick={() => props.closeCustomeAlert()}
            >Got it</Button>
        </Box>
        </Box>
      </Box>
    </Dialog>
  )
}
